import {
  isAlfredDeviceSortField,
  type AlfredDeviceSortField,
  type SortOrder,
} from "@/types/alfred-device"

export const ALFRED_DEVICE_LIST_ORIGIN_STATE = {
  fromAlfredDeviceList: true,
} as const

export interface AlfredDeviceListOrigin {
  clientId?: string
}

export function getAlfredDeviceListOrigin(
  state: unknown,
): AlfredDeviceListOrigin | undefined {
  if (!isRecord(state) || state.fromAlfredDeviceList !== true) return undefined

  const clientId = typeof state.clientId === "string" ? state.clientId.trim() : ""
  return clientId ? { clientId } : {}
}

export interface AlfredDeviceListControlsState {
  page: number
  pageSize: number
  filter: string
  searchInput: string
  sortBy: AlfredDeviceSortField | null
  sortOrder: SortOrder
}

export interface AlfredDeviceListHistoryState {
  controls: AlfredDeviceListControlsState
  selectedClientId?: number | null
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

export function getAlfredDeviceListHistoryState(
  state: unknown,
): AlfredDeviceListHistoryState | undefined {
  if (!isRecord(state) || !isRecord(state.alfredDeviceList)) return undefined

  const snapshot = state.alfredDeviceList
  if (!isRecord(snapshot.controls)) return undefined

  const controls = snapshot.controls
  if (
    !Number.isInteger(controls.page) ||
    Number(controls.page) < 1 ||
    !Number.isInteger(controls.pageSize) ||
    Number(controls.pageSize) < 1 ||
    typeof controls.filter !== "string" ||
    typeof controls.searchInput !== "string" ||
    !(
      controls.sortBy === null ||
      (typeof controls.sortBy === "string" && isAlfredDeviceSortField(controls.sortBy))
    ) ||
    (controls.sortOrder !== "asc" && controls.sortOrder !== "desc")
  ) {
    return undefined
  }

  const selectedClientId = snapshot.selectedClientId
  if (
    selectedClientId !== undefined &&
    selectedClientId !== null &&
    (!Number.isInteger(selectedClientId) || Number(selectedClientId) < 1)
  ) {
    return undefined
  }
  const restoredSelectedClientId =
    selectedClientId === undefined || selectedClientId === null
      ? selectedClientId
      : Number(selectedClientId)

  return {
    controls: {
      page: Number(controls.page),
      pageSize: Number(controls.pageSize),
      filter: controls.filter,
      searchInput: controls.searchInput,
      sortBy: controls.sortBy,
      sortOrder: controls.sortOrder,
    },
    ...(restoredSelectedClientId !== undefined
      ? { selectedClientId: restoredSelectedClientId }
      : {}),
  }
}

export function isAlfredDeviceListOrigin(state: unknown): boolean {
  return getAlfredDeviceListOrigin(state) !== undefined
}
